// The map loads initially as a static map when a location is clicked on or if the map is
// clicked on then the map will change into a dynamic map

import $ from 'jquery';
import _ from 'lodash';

const { UI, Order } = Mobi2Go;

UI.View({
    name: 'locations',
    model: 'Locations',
    el: '[data-view="locations"]',
    templates: {
        locations: $('[data-template="locations"]').html(),
    },

    initialise() {
        this.model.onReady(this.render);

        UI.bind('showLocationOnMap', this.renderDynamicMapAndSetActiveLocation);
    },
    render() {
        const data = {
            regions: this.model.getByRegion(),
            locations: this.model.getAllNotHidden(),
        };
        const html = this.templates.locations(data);

        this.$locations = this.jQuery('[data-locations]');
        this.$locations.html(html);
        this.$el
            .addClass(`m2g-locations--n${this.model.getAllNotHidden().length}`)
            .attr('data-count', this.model.getAllNotHidden().length);

        Mobi2Go.app.onMapsReady(this.renderStaticMap);

        $(window).on(
            'resize.staticMap',
            _.debounce(() => {
                this.renderStaticMap();
            }, 400)
        );
    },
    renderStaticMap() {
        const static_map = this.getStaticMapElement();
        $(this.jQuery('[data-map]')).html(static_map);
    },
    getStaticMapElement() {
        const locations = this.model.getAllNotHidden();
        const zoom = locations.length < 2 ? 'zoom=14&' : '';

        const client_window_width = $(window).width();

        const scale = client_window_width > 640 ? 'scale=2&' : '';

        const markers = locations
            .map(
                ({ address: { latitude, longitude } }) =>
                    `${latitude},${longitude}`
            )
            .join('|');

        const static_map = $('<img/>', {
            class: 'm2g-locations-map-static',
            src: `https://maps.googleapis.com/maps/api/staticmap?size=${client_window_width}x275&${zoom}${scale}markers=${markers}&key=AIzaSyATRGdEGlrSOEy1DcJCVFyD6Ka6wJxWDfQ`,
            alt: 'Store map – Click to zoom',
            loading: 'lazy',
        });

        static_map.css({ 'max-width': `${client_window_width}px` });

        static_map.click(() => {
            this.renderDynamicMap();
            Order.log('clicked on onepager locations map');
        });

        return static_map;
    },
    renderDynamicMap() {
        $(window).off('resize.staticMap');

        if (this.map) {
            return false;
        }

        this.maps = google.maps;
        this.maps.visualRefresh = true;

        const locations = this.model.getAllNotHidden();
        const map_options = {
            // center: new this.maps.LatLng(-34.397, 150.644),
            zoom: 15,
            mapTypeId: this.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
        };

        const map_el = this.jQuery('[data-map]')[0];
        $(map_el).addClass('m2g-locations-map-dynamic');

        this.map = new this.maps.Map(map_el, map_options);
        this.map_bounds = new this.maps.LatLngBounds();

        // Add location markers to map
        _.each(locations, this.addLocationMarker);

        // Fit bounds if there are multiple stores
        // otherwise set map center on single location
        if (locations.length > 1) {
            this.map.fitBounds(this.map_bounds);
        } else if (locations[0]) {
            const { address } = locations[0];
            this.map.setCenter(
                new this.maps.LatLng(+address.latitude, +address.longitude)
            );
        }
        return true;
    },
    addLocationMarker(location) {
        const { address } = location;
        const latlon = new this.maps.LatLng(
            +address.latitude,
            +address.longitude
        );

        // Extend bounds
        this.map_bounds.extend(latlon);

        this.map_markers[location.id] = new this.maps.Marker({
            position: latlon,
            title: location.name,
            map: this.map,
        });
    },
    active_location: null,

    renderDynamicMapAndSetActiveLocation(id) {
        const didInitialise = this.renderDynamicMap();

        setTimeout(
            () => {
                this.setActiveLocation(id);
            },
            didInitialise ? 1000 : 0
        );
    },
    setActiveLocation(id) {
        // Reset marker
        if (this.active_location) {
            const current_marker = this.map_markers[this.active_location];
            current_marker.setZIndex(0);
            current_marker.setAnimation(null);

            this.$locations
                .find(`[data-location="${this.active_location}"]`)
                .removeClass('m2g-location--active');
        }

        this.$locations
            .find(`[data-location="${id}"]`)
            .addClass('m2g-location--active');

        this.map_markers[id].setZIndex(1);
        this.map_markers[id].setAnimation(this.maps.Animation.BOUNCE);
        this.map.panTo(this.map_markers[id].position);

        this.active_location = id;

        if (this.map.getZoom() < 9) {
            this.map.setZoom(9);
        }
    },
    renderLocationInfo(location) {
        location.load(() => {
            const html = this.templates.location_info(location);
            this.jQuery('[data-location-info]').html(html);
        });
    },
    map: null,
    map_bounds: null,
    map_markers: {},
    model_listeners: {},
    DOM_listeners: {
        'click [data-location]': function clickLocation(e) {
            const didInitialise = this.renderDynamicMap();
            const id = this.jQuery(e.currentTarget).data('location');

            setTimeout(
                () => {
                    Order.log('clicked on onepager location');
                    this.setActiveLocation(id);
                },
                didInitialise ? 1000 : 0
            );
        },
    },
});
